import React from "react";
import { numberToSimpleNumberString } from "../../functions/text-formatting";

export default function ListChart({
  title,
  subtitles = [],
  datasets = [],
  icons = [],
}) {
  if (!datasets || !datasets.length) {
    return;
  }

  return (
    <div className="list-chart">
      <div className="list-chart__header">{title}</div>

      {datasets.map((dataset, dIndex) => (
        <React.Fragment>
          <div className="list-chart__table" key={dIndex}>
            <div
              className={`list-chart__table__header ${
                dIndex % 2 !== 0 ? "list-chart__table__header--alt" : ""
              }`}
            >
              {icons[dIndex]}
              {subtitles[dIndex]}
            </div>

            {dataset
              .sort((a, b) => b.value - a.value)
              .map((item, index) => (
                <div className={`list-chart__table__row ${index % 2 ===0 ? "list-chart__table__row--alt" : ""}`} key={index}>
                  <div className="list-chart__table__label">{item.label}</div>
                  <div className="list-chart__table__value">
                    {numberToSimpleNumberString(item.value, item.type)}
                  </div>
                </div>
              ))}
          </div>

          {dIndex < datasets.length - 1 ? (
            <div className="list-chart__divider"></div>
          ) : null}
        </React.Fragment>
      ))}
    </div>
  );
}
